<template>
  <b-container>
    <h1>Nous contacter</h1>
    <b-row class="justify-content-md-center text-center">
      <b-col cols="12" md="5" class="form">
        <Form></Form>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center" align-h="center" align-v="center">
      <Contact
        v-for="contact in contacts"
        :key="contact.name"
        :name="contact.name"
        :address="contact.address"
        :phone="contact.phone"
        :mail="contact.mail"
        :pmr="contact.pmr"
        :directions="contact.directions"
      ></Contact>
    </b-row>
    <b-row class="map">
      <h2>S'y rendre</h2>
      <Map />
    </b-row>
  </b-container>
</template>

<style scoped lang="stylus">
/* Import theme colors palette */
@import '../css/palette.styl';

.map {
  margin-top: 50px;
}

.form {
  border: 5px solid $pastelGreenColor;
  padding: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>

<script>
import Contact from "../components/Contact";
import Map from "../components/Map";
import Form from "../components/Form";

export default {
  data() {
    return {
      contacts: [
        {
          name: "Cabinet d’orthoptie de l’Aurore – St Martin d’Hères",
          address: "9, place Frida KAHLO, 38400 Saint Martin d’Hères",
          phone: "04 76 01 89 13",
          mail: "orthoptie.smh@gmail.com",
          pmr: "Accès PMR",
          directions:
            "Parking dans la rue – Arrêt Tram D : Etienne Grappe - Bus 12 et C6",
        },
        {
          name: "Cabinet d’orthoptie de Vif",
          address: "MSP d'Uriol, 12 rue du stade, 38450 Vif",
          phone: "06 32 87 66 42",
          mail: "orthoptievif@gmail.com",
          pmr: "Accès PMR",
          directions:
            "Parking de la MSP",
        }
      ],
    };
  },
  components: {
    Contact,
    Map,
    Form,
  },
};
</script>
